import { withInstall } from '@mts-fe/utils';
import breadcrumb from './src/Breadcrumb.vue';
import cacheMenu from './src/CacheMenu.vue';
import floatMenu from './src/FloatMenu.vue';

export const CacheMenu = withInstall(cacheMenu);
export const FloatMenu = withInstall(floatMenu);
export const Breadcrumb = withInstall(breadcrumb);
